
import { useState } from 'react'
import './styles/cis.css'
import PanelCis from '../components/cis-components/PanelCis'
import Search from '../components/generales/Search'
import Action from '../components/Action'
import { lang } from '../components/generales/traduction'
import { capitalizeFirstLetter } from '../utils/utils'
import PanelCisInfo from '../components/cis-components/PanelCisInfo'
import PanelCMDB from '../components/cis-components/PanelCMDB'
const Cis=({userPermissions,dataGlobals,globals,languaje,mode,handleShowPopup,pageSelected,server,estados_list,token,estadoSelected,setEstadoSelected
})=>{
  const [cisSelected, setCisSelected] = useState([]);

  return (
      <div className={"main-cis"+mode}>
         {/* <PanelCis handleShowPopup={handleShowPopup} mode={mode} languaje={languaje} server={server}
                  
                  cisSelected={cisSelected} 
                  setCisSelected={setCisSelected}
                  /> */}
                  <PanelCMDB userPermissions={userPermissions} handleShowPopup={handleShowPopup} mode={mode} languaje={languaje} server={server}
                  
                  cisSelected={cisSelected} 
                  setCisSelected={setCisSelected}
                 
                    estados_list={estados_list}
                   
                    
                   
                    token={token}
                    dataGlobals={globals.data.data}
                    estadoSelected={estadoSelected}
                    setEstadoSelected={setEstadoSelected}
                    
                  />
                  {/* {(cisSelected.length==0)?
                  <PanelCis handleShowPopup={handleShowPopup} mode={mode} languaje={languaje} server={server}
                  
                  cisSelected={cisSelected} 
                  setCisSelected={setCisSelected}
                  />:
                  <PanelCisInfo handleShowPopup={handleShowPopup} mode={mode} languaje={languaje} server={server}
                  
                  cisSelected={cisSelected} 
                  setCisSelected={setCisSelected}
                  />
                  } */}
              
      </div>
  )
}

export default Cis